import Config from './config'

/**
 * Inicializuje meta data letáku
 */
export function leafletPageLinks()
{
    // json
    const meta = Config.get('leafletPage');

    // dodatečné info o letáku potřebné pro GA
    const metaGA = Config.get('leafletPageGa');

    // pokud nejsou meta, končíme
    if (meta === null)
    {
        return;
    }

    // obrázek letáku
    const leaflet = document.getElementById('leaflet');

    // rozmery body
    const bodyRect = document.body.getBoundingClientRect();

    // vytvoříme elemnt, který dáme přes obrázek
    const leafletPage = document.createElement('div');
    leafletPage.id = 'leaflet-page-id';

    const leafletPaddingLeft = parseInt(window.getComputedStyle(leaflet).getPropertyValue('padding-left').match(/\d+/)[0]);
    const leafletPaddingTop = parseInt(window.getComputedStyle(leaflet).getPropertyValue('padding-top').match(/\d+/)[0]);

    const leafletPosition = {
        x: leaflet.getBoundingClientRect().top - bodyRect.top + leafletPaddingLeft,
        y: leaflet.getBoundingClientRect().left - bodyRect.left + leafletPaddingTop
    };

    // pozice na leták
    leafletPage.style.position = 'absolute';
    leafletPage.style.top = leafletPosition.x + 'px';
    leafletPage.style.left = leafletPosition.y + 'px';
    leafletPage.style.width = leaflet.width + 'px';
    leafletPage.style.height = leaflet.height + 'px';

    // přidáme linky na obrázky letáku
    meta.map((card) => {

        // a, kde budeme mít proklik z obrázku
        const imageHref = document.createElement('a');

        imageHref.href = card.imageUrl;

        // přídáme data, potřebná pro zaslání eventu do ga a classu
        imageHref.dataset.storeName = metaGA.storeName;
        imageHref.dataset.leafletUrl = metaGA.leafletUrl;
        imageHref.dataset.remoteStoreUrl = card.imageUrl;
        imageHref.className = 'ga-product';

        // základní pozice div elementu
        const imageElement = document.createElement('div');

        imageElement.style.position = 'absolute';
        imageElement.style.display = 'inline-block';
        imageElement.style.left = (card.image.x * leaflet.width) + 'px';
        imageElement.style.top = (card.image.y * leaflet.height) + 'px';
        imageElement.style.width = (card.image.sizeX * leaflet.width) + 'px';
        imageElement.style.height = (card.image.sizeY * leaflet.height) + 'px';

        imageHref.appendChild(imageElement);
        imageHref.setAttribute('target', '_blank');

        // dáme do leafletPage
        leafletPage.appendChild(imageHref);

        // proklik košíku
        if (card.cart !== null) {

            // a, kde budeme mít proklik z obrázku
            const cartHref = document.createElement('a');

            cartHref.href = card.cartUrl;
            cartHref.setAttribute('target', '_blank');

            // základní pozice img elementu
            const cartElement = document.createElement('div');

            cartElement.style.backgroundImage = 'url("/www/img/shopping/shopping-trolley-pink.png")';
            cartElement.style.backgroundSize = (card.cart.sizeX * leaflet.width) + 'px ' + (card.cart.sizeY * leaflet.height) + 'px';

            // impelemntace hoveru
            cartElement.addEventListener("mouseover", (event) => {
                event.target.style.backgroundImage = 'url("/www/img/shopping/shopping-trolley-blue.png")';
                event.target.style.backgroundSize = (card.cart.sizeX * leaflet.width) + 'px ' + (card.cart.sizeY * leaflet.height) + 'px';
            });

            cartElement.addEventListener("mouseout", (event) => {
                event.target.style.backgroundImage = 'url("/www/img/shopping/shopping-trolley-pink.png")';
                event.target.style.backgroundSize = (card.cart.sizeX * leaflet.width) + 'px ' + (card.cart.sizeY * leaflet.height) + 'px';
            });

            cartElement.style.position = 'absolute';
            cartElement.style.display = 'inline-block';
            cartElement.style.left = (card.cart.x * leaflet.width) + 'px';
            cartElement.style.top = (card.cart.y * leaflet.height) + 'px';
            cartElement.style.width = (card.cart.sizeX * leaflet.width) + 'px';
            cartElement.style.height = (card.cart.sizeY * leaflet.height) + 'px';

            cartHref.appendChild(cartElement);

            // dáme do leafletPage
            leafletPage.appendChild(cartHref);
        }
    });

    // přídáme do body
    document.body.appendChild(leafletPage);

    // inicializujeme ga pro produkty
    gaInitPushLeafletSale();
}

function gaInitPushLeafletSale()
{
    $('.ga-product').on('click', function() {

        gtag('event', 'Online leták proklik', {
            'event_category': $(this).data('storeName'),
            'event_label': $(this).data('remoteStoreUrl'),
        });
    });
}